import React, { useState } from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import translator from '../../translator';
import moment from 'moment';
import style from './style/maintenancenotificationbar.scss';

const MaintenanceNotificationBar = ({ maintenanceDate, languageId }) => {
    const i18n = translator(languageId, ['maintenance']);
    const [open, setOpen] = useState(!!maintenanceDate);

    return (
        <Snackbar
            open={open}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            classes={{ root: style.notificationBar }}
        >
            <Alert severity="info" onClose={() => setOpen(false)} classes={{ root: style.alert }} variant="filled">
                {`${i18n.maintenance_notification_bar_text_a} ${moment(maintenanceDate).format('DD-MM-YYYY')} ${i18n.maintenance_notification_bar_text_b}`}
            </Alert>
        </Snackbar>
    );
};

export default MaintenanceNotificationBar;
